export interface ICloud {
  id?: number;
  uuid?: string;
  description: string,
 project_id: number,
 category_id: number,
 user_id: number,
 file?: File
}


export const cloudInitValues: ICloud = {
 //id: 0,
 description: '',
 project_id: 0,
 category_id: 0,
 user_id: 0
}

